module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.425 50.425"><path d="M41.05 40.081a3.236 3.236 0 0 0-3.232 3.232v7.111l10.343-10.343H41.05z"/><path d="M11.313 6.465V43.96c0 3.556 2.909 6.465 6.465 6.465h16.808v-7.111c0-3.556 2.909-6.465 6.465-6.465h7.111l.001-30.384h-36.85zm19.393 26.181H19.07v-3.232h11.636v3.232zm9.698-7.757H19.07v-3.232h21.333v3.232zm0-7.758H19.07v-3.232h21.333v3.232z"/><path d="M2.263 0v37.495c0 3.337 2.563 6.105 5.818 6.432V3.232h31.032V0H2.263z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/111-file.svg
// module id = 1244
// module chunks = 1